<template>
  <div id="home">
    <my-header></my-header>
    <div class="pd20">
      <form v-on:submit.prevent="submitForm">
        <h3 class="mt0">{{getTitleText}}</h3>
        <ul class="breadcrumb">
          <li>
            <router-link :to="{ name: 'Quotes'}">{{'Request Quotes'|translate}}</router-link>
          </li>
          <li>{{getTitleText}}</li>
        </ul>
        <div class="row">

          <div class="col-md-12 mb20">
            <label class="mt20">{{'Danh mục sản phẩm'|translate}}:</label>
            <!-- <select
            class="form-control mb20"
            v-if="product_categories"
            v-on:change="filterProducts()"
            v-model="selected_product_category"
          >
            <option v-for="item in product_categories" :value="item.id" :key="item.id">{{ item.name }}</option>
          </select> -->
            <div>
            <div class="radio inline-block" v-for="(item) in product_categories" :key="item.id">
              <label>
                <input type="radio" v-bind:value="item.id" v-model="selected_product_category" v-on:change="filterProducts()" />
                {{item.name}}
              </label>
              &nbsp;
              &nbsp;
            </div>
            </div>

            <label class="mt20" >Sản phẩm:</label>
            <div class="row" >
              <div class="col-6 col-md-6" v-for="product in filter_products" v-bind:key="product.id"  >
                <input type="checkbox" :disabled="item.id" :id="product.id" :value="product.id" v-model="selected_product_ids">
                <label class="no-strong" :for="product.id">{{product.name}}</label>
            </div>
          </div>

          <p>&nbsp;</p>
          <div >
            <label>Sản phẩm đã chọn:</label>
            <p v-if="selected_product_ids.length == 0" >Bạn chựa chọn sản phẩm nào </p>
            <div v-else>
              <p class="tag inline-block mr20" v-for="product_id in selected_product_ids" :key="product_id">
                {{getProductName(product_id)}} <a class="pointer" v-on:click="removeProduct(product_id)" ><i v-if="!item.id" class="fa fa-times"></i></a>
              </p>
            </div>
          </div>

          </div>
          <div class="col-md-12">
            <label>{{'Ghi chú'|translate}}:</label>
            <input
              v-model="item.note"
              ref="note"
              :disabled="item.id"
              required
              :placeholder="'Input note'|translate"
              class="form-control"
            />

            <label class="mt20" >{{'Shipping Address'|translate}}:</label>
            <input
              v-model="item.shipping_address"
              ref="shipping_address"
              required
              :disabled="item.id"
              :placeholder="'Input shipping address'|translate"
              class="form-control"
            />

          </div>
        </div>

        <button v-if="!item.id" class="btn btn-info mt20" type="submit" :disabled="working">
          <i v-if="working" class="fas fa-spinner fa-spin"></i>
          {{getOKText}}
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import Loading from '@/components/elements/Loading'
import selectlocation from '@/components/elements/SelectLocation'
import Utils from '@/helpers/utils'
import LocationHelper from '@/helpers/location'
import MyHeader from '@/components/Layout/Header'
// import GoogleAutocomplete from 'google-autocomplete-vue';
export default {
  name: 'FormGarden',
  components: {
    Loading,
    selectlocation,
    MyHeader
  },
  computed: {
    getTitleText () {
      if (this.item.id) {
        return this.$t('View quote')
      } else {
        return this.$t('Add quote')
      }
    },
    getOKText () {
      if (this.item.id) {
        return this.$t('View')
      } else {
        return this.$t('Add')
      }
    }
  },
  data () {
    return this.defaultData()
  },
  created () {
    // clone from original params
  },
  watch: {
    $route (to, from) {
      console.log('from', from)
      console.log('to', to)
      let defaultData = this.defaultData()

      for (var key in defaultData) {
        this[key] = defaultData[key]
      }

      this.item = this.defaultValue()
      this.loadInfo()
    }
  },
  methods: {
    defaultData () {
      return {
        ready: false,
        working: false,
        selected_product_category: null,
        all_products: [],
        filter_products: [],
        product_categories: [],
        selected_product_ids: [],

        item: {}
      }
    },
    defaultValue () {
      return {
        note: '',
        shipping_address: ''
      }
    },

    init () {
      if (this.item.id) {
      } else {
        this.item = this.defaultValue()
      }
      this.ready = true
    },
    submitForm () {
      if (this.selected_product_ids.length == 0) {
        return Utils.showError(this, 'Bạn cần chọn sản phẩm trước khi tiếp tục')
      }
      let data = JSON.parse(JSON.stringify(this.item))

      data.product_ids = this.selected_product_ids

      let request
      if (this.item.id) {
        request = Utils.requestV2(this, true).put(
          `/quotes/`,
          data
        )
      } else {
        request = Utils.requestV2(this, true).post(
          `/quotes/`,
          data
        )
      }
      this.working = true
      request
        .then(response => {
          let data = response.data
          console.log('data', data)

          this.logicFinish()
        })
        .catch(error => {
          this.working = false
          Utils.showErrorMessage(this, error.response)
        })
    },

    logicFinish () {
      if (this.item.id) {
        this.$alertify.success(this.$t('Your quote is updated'))
      } else {
        this.$alertify.success(this.$t('Your quote is added'))
        this.$router.push({ name: 'Quotes' })
      }
      this.working = false
    },
    filterProducts () {
      this.filter_products = this.all_products.filter(product => product.category && product.category.id == this.selected_product_category)
    },
    getProductName (productId) {
      let temp = this.all_products.filter(product => product.id == productId)
      return temp.length > 0 ? temp[0].name : ''
    },
    removeProduct (productId) {
      const index = this.selected_product_ids.indexOf(productId)
      if (index > -1) {
        this.selected_product_ids.splice(index, 1)
      }
    },
    loadInfo () {
      this.quote_id = this.$route.params.id

      let wating = []

      wating.push(Utils.getAllProducts(this, {}))

      if (this.quote_id) {
        wating.push(
          Utils.requestV2(this, true).get(
            `/quotes/${this.quote_id}`
          )
        )
      } else {
        LocationHelper.getMyLocationWithAddress().then((position) => {
          this.item.shipping_address = position.address
        })
      }

      Promise.all(wating).then(values => {
        if (this.quote_id) {
          this.item = values[1].data
          // this.item.is_conv
          console.log('this.item', this.item)

          this.item.business_quote_details.forEach(element => {
            this.selected_product_ids.push(element.product.id)
          })
          console.log('this.selected_product_ids', this.selected_product_ids)
        }

        this.all_products = values[0]
        Utils.getAllProductCategories().then(result => {
          this.product_categories = result
          // this.product_categories.forEach(product => {
          //   selected_products[product.id] = false;
          // });
          if (this.product_categories.length > 0) {
            this.selected_product_category = this.product_categories[0].id
            this.filterProducts()
          }
        })

        this.init()
      })
    }
  },

  mounted () {
    this.loadInfo()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/FormQuote.vue